import { Fragment } from 'react';

import { getCurrencySymbol } from '@utils/utils';

import { PriceProps } from './type';
import {
  Container,
  Currency,
  Decimals,
  DecimalsCurrency,
  Whole,
  WithOriginalPrice,
} from './style';
import { getNumberParts } from './utils';

const Price = ({
  price,
  currency = 'TL',
  color = 'darkGrey',
  originalPrice,
  Wrapper = originalPrice ? WithOriginalPrice : Fragment,
  format = 'normal',
  total,
  currencyFontSize,
  currencyFontWeight = 600,
  showDecimal = true,
  decimalCurrencyFlexDirection = 'column',
  decimalFontSize = 12,
  sellingPrice,
  children,
  fontSize,
  isPackage,
  priceInEuro,
  periodType,
  isReservationSum,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  originalPriceCurrency,
  ...rest
}: PriceProps) => {
  const [whole, decimal] = getNumberParts(sellingPrice ? sellingPrice : price);

  return (
    <Wrapper {...rest}>
      {children}
      <Container
        color={color}
        format={format}
        centered
        decimalFontSize={decimalFontSize}
      >
        <Whole
          total={total || priceInEuro}
          fontSize={fontSize ? fontSize : total ? 22 : 30}
          isPackage={isPackage}
          periodType={periodType}
          isReservationSum={isReservationSum}
        >
          {whole}
        </Whole>
        <DecimalsCurrency
          decimalCurrencyFlexDirection={decimalCurrencyFlexDirection}
        >
          {showDecimal ? <Decimals total={total}>,{decimal}</Decimals> : null}
          <Currency
            periodType={periodType}
            fontSize={currencyFontSize}
            fontWeight={currencyFontWeight}
          >
            {getCurrencySymbol(currency) || currency}
          </Currency>
        </DecimalsCurrency>
      </Container>
    </Wrapper>
  );
};

export default Price;
